'use client';

import React from 'react';

import {AsyncStaticPriceText} from '@udemy-v2/react-course-pricing';
import {useMatchMedia} from '@udemy-v2/design-system-utils';
import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import {ClpCartSuccessModal} from '@/features/course-landing-page/components/clp-cart-success-modal';

import {AddToCartButton} from '@udemy-v2/react-shopping-buttons';
import styles from './transactional-sticky-footer-content.module.scss';

/**
 * TransactionalStickyFooterContent component displays price and CTA button for transactional purchases.
 * Renders for paid courses that are not included in a subscription and when the user is not already enrolled.
 */
export const TransactionalStickyFooterContent: React.FC = () => {
    const course = useClpCourse();
    const isMobile = useMatchMedia('sm-max');

    return (
        <div className={styles.container}>
            <AsyncStaticPriceText listPriceClassName="ud-heading-lg" courseId={Number(course.id)} />
            <AddToCartButton
                buyables={[
                    {
                        id: Number(course.id),
                        buyableObjectType: 'course',
                        frontendTrackingId: course.frontendTrackingId,
                    },
                ]}
                buttonStyleProps={{
                    size: 'large',
                    typography: 'ud-heading-md',
                    udStyle: 'primary',
                }}
                className={styles['transactional-cta-button']}
                addToCartSuccessModal={
                    !isMobile ? <ClpCartSuccessModal course={course} /> : undefined
                }
                forceRedirectToCart={!!isMobile}
            />
        </div>
    );
};
